import { Container, styled } from '@mui/material';

const ContainerCenteredStyled = styled(Container)`
  text-align: center;
`;

export { ContainerCenteredStyled };
